import type { TradeInfo, PaymentTerm } from '~/contracts/srp';
import FinanceInfoFromApi from './FinanceInfo';

export const nonSearchableError =
  'Unable to find any of the requested vehicles in ElasticSearch';

export enum PricingError {
  None = 'None',
  NoVehiclePricingInfo = 'No terms found for vehicle',
  NonSearchable = 'Vehicle not in Elastic Search',
  ApiError = 'Error fetching pricing'
}

type PricingResponse = {
  financeInfo: FinanceInfoFromApi;
  tradeInfo?: TradeInfo;
  vehiclePaymentTermsMapping: Record<number, PaymentTerm>;
};

export default PricingResponse;
